import { setXavisExperiments } from './debug';
import { yEqual, yCopy, yIsEmpty } from './object';

export namespace $storage {
    export let is_available = false;
    let can_persist = false;

    try {
        sessionStorage.setItem('_y_storage_test', '42');
        sessionStorage.removeItem('_y_storage_test');
        is_available = true;
        localStorage.setItem('_y_storage_test', '42');
        localStorage.removeItem('_y_storage_test');
        can_persist = true;

        if(localStorage.getItem('xavis_experiments'))
            setXavisExperiments(true);
    } catch(e) {}

    export function putString(key: string, value?: string, persist?: boolean) {
        if(!is_available) return;
        if(value == undefined) {
            sessionStorage.removeItem(key);
            can_persist && localStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, value);
            if(persist && can_persist)
                localStorage.setItem(key, value);
        }
    }

    export function putObject(key: string, obj: any, persist?: boolean) {
        putString(key, obj == undefined ? undefined : JSON.stringify(obj), persist);
    }

    export function getString(key: string, remove?: boolean) {
        if(!is_available) return undefined;
        let value = sessionStorage.getItem(key);
        if(value == null) {
            if(can_persist) {
                value = localStorage.getItem(key);
                if(value != null) {
                    if(remove)
                        localStorage.removeItem(key);
                    return value;
                }
            }
        } else {
            if(remove) {
                sessionStorage.removeItem(key);
                can_persist && localStorage.removeItem(key);
            }
            return value;
        }
        return undefined;
    }

    export function getObject(key: string, remove?: boolean) {
        const value = getString(key, remove);
        return value != undefined ? JSON.parse(value) : undefined;
    }

    export function remove(key: string) {
        if(!is_available) return;
        sessionStorage.removeItem(key);
        can_persist && localStorage.removeItem(key);
    }

    let preferences: { [key: string]: any } = (is_available && getObject('preferences')) || {};

    let unsaved_preferences: { [key: string]: string } = {};
    export let preference_save_hook: (preferences: { [key: string]: string }) => void;

    export function setPreference(key: string, value: any) {
        if(yEqual(value, preferences[key])) return;

        preferences[key] = yCopy(value);
        unsaved_preferences[key] = JSON.stringify(value);

        if(is_available)
            putObject('preferences', preferences, true);
    }

    export function getPreference(key: string, def?: any) {
        const v = preferences[key];
        if(v === undefined)
            return def;
        return yCopy(v);
    }

    export function commitPreferences() {
        if(preference_save_hook && !yIsEmpty(unsaved_preferences)) {
            preference_save_hook(unsaved_preferences);
            unsaved_preferences = {};
        }
    }

    export function loadPreferences(prefs: { [key: string]: string }) {
        unsaved_preferences = {};

        const new_preferences: { [key: string]: any } = {}
        for(const key in prefs) {
            new_preferences[key] = JSON.parse(prefs[key]);
        }

        for(const key in preferences) {
            if(!(key in new_preferences)) {
                new_preferences[key] = preferences[key];
                unsaved_preferences[key] = JSON.stringify(preferences[key]);
            }
        }

        preferences = new_preferences;
    }

    export function discardPreferences() {
        preferences = {};
        unsaved_preferences = {};
        remove('preferences');
    }

    export function once(key: string) {
        if(preferences[key]) return false;
        setPreference(key, true);
        commitPreferences();
        return true;
    }
}
